import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { SecurityProfileModel } from './security-profile.model';
import { SecurityProfileStore } from './security-profile.store';

@Injectable({ providedIn: 'root' })
export class SecurityProfileQuery extends QueryEntity<SecurityProfileModel, SecurityProfileModel> {
  protected store: SecurityProfileStore;

  constructor() {
    const store = inject(SecurityProfileStore);

    super(store);

    this.store = store;
  }
}
